import React from 'react'
import { CambiarContrasenaProvider } from '../context/cambiarContrasena.context'
import CambioContrasena from '../components/CambioContrasena'
import { Accordion, AccordionTab } from 'primereact/accordion'

const CambiarContrasena = () => {

  return (
    <div className="accordion-demo">
      <div className="card">
    <Accordion multiple activeIndex={[0,1]}>
      <AccordionTab  header="CAMBIO CONTRASEÑA">
    <CambiarContrasenaProvider>
        <CambioContrasena/>
    </CambiarContrasenaProvider>    
    </AccordionTab>
    </Accordion>
    </div>
    </div>
  )
}

export default CambiarContrasena